Namespace 'Common.Dashboard.Filters'

Common.Dashboard.Filters.AssignedAdvisorFilterMixin =
  _getSelectedValues: ->
    filters = []
    robot = _.contains(@groupSelectorView.getSelectedValues(), @filter.constructor.ROBOT_FILTER_TYPE)
    noAssignation = _.contains(@groupSelectorView.getSelectedValues(), @filter.constructor.NOBODY_FILTER_TYPE)
    filters = @_addHumanFilter(filters)
    filters.push @_robotAdvisorFilter() if robot
    filters.push @_noAssignationFilter() if noAssignation
    filters

  _addHumanFilter: (filters) ->
    advisorIds = _.without(
      @groupSelectorView.getSelectedValues(),
      @filter.constructor.NOBODY_FILTER_TYPE,
      @filter.constructor.ROBOT_FILTER_TYPE
    )
    filters.push @_humanAdvisorsFilter(advisorIds) unless _.isEmpty(advisorIds)
    filters

  _humanAdvisorsFilter: (ids) ->
    ids: ids
    type: @filter.constructor.HUMAN_FILTER_TYPE

  _robotAdvisorFilter: ->
    type: @filter.constructor.ROBOT_FILTER_TYPE

  _noAssignationFilter: ->
    type: @filter.constructor.NOBODY_FILTER_TYPE

  _displayTitle: ->
    I18n.t 'customer_visual_mode.filters.assigned_advisor'

  openAssignedAdvisorFilterModal: ->
    @groupSelectorView?.remove()
    @groupSelectorView = new CustomerVisualMode.Filters.SingleFilters.AssignedAdvisorFilterView(
      filter: @filter
      selectedOptions: @filter.getValues(@advisors.models).map((value) -> value.id)
      advisors: @advisors
    ).render()
    @listenTo(@groupSelectorView, 'filters:multiplevalues:apply', @applyFilter)
